import {
  Box,
  Grid,
  Paper,
} from "@mui/material";
import styled from "styled-components";

interface PageCardProps {
  padding: number;
  backgroundRequired: boolean
}

export const PageCard = styled(Box)<PageCardProps>(({ theme, padding, backgroundRequired = true }) => ({
  padding: theme.spacing(padding),
  backgroundColor: (backgroundRequired) ? theme.palette.white.main : 'transparent',
  borderRadius: theme.palette.custom.borderRadius,
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(4),
}));


export const BasicDetailItemContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2),
  minHeight: theme.spacing(9)
}));


export const BasicDetailItemBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const CustomCard = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));



export const ButtonGroupContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'flex-end',
}));


export const VerificationImageContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
    // You'll need to define a max size for the icon so it doesn't break the layout
    width: '40px',
    height: '40px',
  },
}))

export const SectionHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(2, 3),
  marginBottom: theme.spacing(3),
  borderRadius: theme.palette.custom.borderRadius,
}));

export const SectionTitle = styled('h2')(({ theme }) => ({
  color: theme.palette.white.main,
  margin: 0,
  fontSize: '1.25rem',
  fontWeight: 500,
}));


export const VideoPlayerBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#4A4A4A',
  borderRadius: theme.palette.custom.borderRadius,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '370px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: '#5A5A5A',
  },
}));

export const VideoPlayerText = styled('span')(({ theme }) => ({
  color: theme.palette.white.main,
  fontSize: '1.125rem',
  fontWeight: 400,
}));

export const InterviewDetailsCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.palette.custom.borderRadius,
  minHeight: '370px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
}));

export const DetailsTitle = styled('h3')(({ theme }) => ({
  margin: 0,
  marginBottom: theme.spacing(3),
  fontSize: '1.375rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const DetailRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(3),
  gap: theme.spacing(4),
}));

export const DetailColumn = styled(Box)({
  flex: 1,
});

export const DetailLabel = styled('div')(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: '0.875rem',
  fontWeight: 500,
  marginBottom: theme.spacing(0.5),
}));

export const DetailValue = styled('div')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '1rem',
  fontWeight: 400,
}));

export const FeedbackNotesCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.palette.custom.borderRadius,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
}));

export const FeedbackTitle = styled('h3')(({ theme }) => ({
  margin: 0,
  marginBottom: theme.spacing(2),
  fontSize: '1.25rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const FeedbackContent = styled(Box)(({ theme }) => ({
  backgroundColor: '#F8F9FB',
  padding: theme.spacing(3),
  borderRadius: theme.palette.custom.borderRadius,
  fontSize: '1rem',
  lineHeight: 1.6,
  color: theme.palette.text.primary,
}));